<template>
    <div id="call_history">
        <h3 class="text-primary text-center"
               >DANH SÁCH CUỘC GỌI 
            </h3>
    <div class="vx-card p-4" >

        <!-- <div class="vx-row">
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Nhân sự</label>
                <v-select v-model="selectedEmployeeValue" :options="employeeOptions"
                          :clearable="false" name="employee" :reduce="item => item.value">
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 sm:mt-0 mt-2 w-full">
                <label class="vs-input--label">Loại</label>
                <v-select v-model="selectedTypeCallValue" :options="typeCallOptions"
                          :clearable="false" name="employee" :reduce="item => item.value">
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 md:mt-0 mt-2 w-full">
                <label class="vs-input--label">Ngày bắt đầu</label>
                <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates"
                            v-model="startDate" name="Ngày bắt đầu" @update="dateRangePicker">
                </datepicker>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full xl:mt-0 mt-2">
                <label class="vs-input--label">Ngày kết thúc</label>
                <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates"
                            v-model="endDate" name="Ngày kết thúc" @update="dateRangePicker">
                </datepicker>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 mt-2 w-full">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="w-full" v-model="phoneNumber" placeholder="Tìm kiếm theo số điện thoại ..."
                          v-on:keydown.enter="filter"></vs-input>
            </div>
            <div class="vx-col w-autol">
                <vs-button class="sm:mt-8" @click="filter">Tìm kiếm</vs-button>
            </div>
        </div> -->
        <div>
            <vs-table :data="callHistoryData" noDataText="Không có dữ liệu"
            style="height: calc(var(--vh, 1vh) * 100 - 200px); min-height: 300px">
            <template slot="thead">
                <vs-th style="min-width: 300px">
                    Trạng thái cuộc gọi
                </vs-th>
                <vs-th style="min-width: 200px">
                    <div class="w-full">
                        <label class="vs-input--label">Nhân viên</label>
                        <v-select v-model="selectedEmployeeValue" :options="employeeOptions" :clearable="false"
                            name="employee" :reduce="item => item.value" @input="filter">
                        </v-select>
                    </div>
                </vs-th>
                <vs-th style="min-width: 200px">
                    <div class="w-full">
                        <label class="vs-input--label">  Khách hàng
                        </label>
                        <vs-input v-model="loyaltyCustomerName"  @keyup.enter="filter" ></vs-input>
                    </div>
                </vs-th>
                <vs-th style="min-width: 200px">
                    <div class="w-full">
                        <label class="vs-input--label"> Thời gian bắt đầu
                        </label>
                        <datepicker :highlighted="highlightedFn" :language="vi" :format="'dd/MM/yyyy'"
                            v-validate="'required'" :disabled-dates="disabledDates" v-model="startDate"
                            name="Ngày bắt đầu" @update="dateRangePicker" @input="filter">
                        </datepicker>
                    </div>

                </vs-th>
                <vs-th style="min-width: 200px">
                    Đối tượng bắt máy
                </vs-th>
                <vs-th style="min-width: 250px">
                    Ghí chú
                </vs-th>
                <vs-th style="min-width: 250px">
                    File ghi âm
                </vs-th>
                <vs-th style="min-width: 250px">
                    Tổng thời gian
                </vs-th>
                <vs-th style="min-width: 250px">
                    Hành động
                </vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <CellRendererType :rowData="tr"></CellRendererType>
                    </vs-td>
                    <vs-td class="text-primary">
                        <CellRendererEmployee :rowData="tr"></CellRendererEmployee>
                    </vs-td>
                    <vs-td>
                        <CellRendererCustomer :rowData="tr"></CellRendererCustomer>
                    </vs-td>
                    <vs-td>
                        {{ tr.createdDateCvt }}
                    </vs-td>
                    <vs-td>
                    </vs-td>
                    <vs-td>
                    </vs-td>
                    <vs-td>
                        <CellRendererRecord :rowData="tr"></CellRendererRecord>
                    </vs-td>
                    <vs-td class="cursor-pointer hover:font-semibold hover:underline over-text">
                        {{ tr.time_call }}
                    </vs-td>
                    <vs-td>
                        <CellRendererActions :rowData="tr"></CellRendererActions>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
       
        </div>
        <div class="vx-row" v-if="callHistoryData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    callHistoryData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : callHistoryData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
            </div>
        </div>
      
        <vs-popup class="holamundo" id="popup-history-call" :active.sync="showCallHistoryDetails">
            <div class="vx-row">
                <div class="vx-col w-full flex justify-between">
                    <h4>Cuộc gọi</h4>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                        @click="closeCallHistoryDetails" />
                </div>
            </div>

            <vs-divider />

            <h5>Chi tiết</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col w-1/3 flex items-center">
                            <span class="text-md font-semibold">Loại</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-chip class="ag-grid-cell-chip"
                                :color="callHistoryDetails ? chipColorType(callHistoryDetails.type_call) : null">
                                <span class="text-md font-semibold">{{
                                    callHistoryDetails ? checkStatusType(callHistoryDetails.type_call) : null
                                    }}</span>
                            </vs-chip>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Thời gian</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <span class="text-md">{{ callHistoryDetails ? callHistoryDetails.createdDate : null
                                }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Thời lượng</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <span class="text-md">{{ callHistoryDetails ? callHistoryDetails.time_call : null }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4">
                        <div class="vx-col w-1/3">
                            <span class="text-md font-semibold">Hotline</span>
                        </div>
                        <div class="vx-col w-2/3">
                            <span class="text-md font-semibold">{{
                                callHistoryDetails ? callHistoryDetails.hotline_number : null
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <vs-divider />

            <h5>Người gọi</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-1/2">
                    <span>{{ callHistoryDetails ? callHistoryDetails.callerMem : null }}</span>
                    <span>{{ callHistoryDetails ? ' - ' + callHistoryDetails.caller[0].source : null }}</span>
                    <p>{{ callHistoryDetails ? callHistoryDetails.caller[0].phone : null }}</p>
                </div>
                <div class="vx-col w-1/2" v-if="callHistoryDetails && callHistoryDetails.record_file.length > 0">
                    <div v-for="(record, index) in callHistoryDetails.record_file" :key="index"
                        class="text-primary float-right text-md font-semibold cursor-pointer flex items-center"
                        @click="startRecord(record)">
                        <span>{{ 'Tệp ghi âm ' + (index + 1) }}</span>
                        <feather-icon icon="PlayCircleIcon" class="action-success icon-btn" svgClasses="h-5 w-5" />
                    </div>
                </div>
            </div>

            <vs-divider />

            <h5>Người nhận</h5>
            <div v-if="callHistoryDetails && callHistoryDetails.callee.length > 0">
                <div class="vx-row mt-4" v-for="(callee, index) in callHistoryDetails.employee" :key="index">
                    <div class="vx-col w-1/2 flex items-center">
                        <span>{{ callee.user ? callee.user.fullName : 'Không xác định' }}</span>
                        <span>{{ ' - ' + callee.source }}</span>
                    </div>
                    <div class="vx-col w-1/2">
                        <vs-chip class="ag-grid-cell-chip float-right"
                            :color="chipColorDisposition(callee.disposition)">
                            <span class="text-md font-semibold">{{
                                checkStatusDisposition(callee.disposition)
                                }}</span>
                        </vs-chip>
                    </div>
                </div>
            </div>

            <vs-divider />

            <h5>Đánh giá</h5>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <star-rating v-model="rating" :star-size="25" :show-rating="false" :read-only="isRating"
                        :border-width="4" border-color="#F3D23E" active-color="#F3D23E" :rounded-corners="true"
                        :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
                        class="mt-2"></star-rating>
                </div>
                <div class="vx-col w-full">
                    <vs-textarea class="w-full" v-model="review" aria-placeholder="Nhập đánh giá ..."
                        :disabled="isRating" />
                </div>
            </div>

            <div class="mt-4">
                <div class="flex float-right">
                    <vs-button color="primary" @click="saveReviewCall" class="mr-4" v-if="!isRating">Lưu</vs-button>
                    <vs-button color="danger" type="border" @click="closeCallHistoryDetails">Đóng
                    </vs-button>
                </div>
            </div>

            <!--Popup audio record-->
            <vs-popup class="holamundo" id="popup-history-call-record" :active.sync="showAudioRecord">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Ghi âm</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                            @click="closeAudioRecord" />
                    </div>
                </div>
                <vs-divider />
                <div class="vx-row" v-if="showAudioRecord">
                    <div class="vx-col w-full">
                        <audio autoplay name="media" controls :src="dataRecord" type="audio/wav" class="w-full">
                        </audio>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
    </div>
    
</template>

<script>

import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererType from "./cell-renderer/CellRendererType";
import StarRating from 'vue-star-rating';
import Datepicker from 'vuejs-datepicker';
import { en, vi } from 'vuejs-datepicker/dist/locale';
import vSelect from 'vue-select';
import authConfig from '../../../../../auth_config.json';
import CellRendererCaller from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererCaller";
import CellRendererCallee from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererCallee";
import CellRendererRecord from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererRecord";
import CellRendererActions from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererActions";
import CellRendererEmployee from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererEmployee";
import CellRendererCustomer from "@/views/user-pages/crm-module/call-center/cell-renderer/CellRendererCustomer";

export default {
    name: "CallHistory",

    components: {
        AgGridVue,
        CellRendererStatus,
        CellRendererType,
        StarRating,
        Datepicker,
        vSelect,
        CellRendererCaller,
        CellRendererCallee,
        CellRendererRecord,
        CellRendererActions,
        CellRendererEmployee,
        CellRendererCustomer,
    },

    data() {
        return {
            pageNumber: 0,
            pageSize: 20,
            phoneNumber: null,
            currentPage: 1,
            gridApi: null,
            gridOptions: {
                rowHeight: 70
            },
            defaultColDef: {},
            totalPages: 1,
            totalElements: 0,
            callHistoryData: [],
            showCallHistoryDetails: false,
            callHistoryDetails: null,
            dataRecord: null,
            showAudioRecord: false,
            rating: null,
            isRating: false,
            review: null,
            startDate: null,
            endDate: new Date(new Date().setHours(23, 59, 59, 999)),
            en: en,
            vi: vi,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            employeeOptions: [],
            selectedEmployeeValue: 'null',
            typeCallOptions: [
                { value: null, label: 'Tất cả' },
                { value: 'OUTCALL', label: 'Cuộc gọi đi' },
                { value: 'INCALL', label: 'Cuộc gọi đến' },
                { value: 'MISSCALL', label: 'Cuộc gọi nhỡ' },
            ],
            selectedTypeCallValue: null,
            loyaltyCustomerName:null,
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
    },

    computed: {
        chipColorType() {
            return value => {
                if (value == "OUTCALL") {
                    return "success";
                } else if (value == "INCALL") {
                    return 'warning'
                } else if (value == "MISSCALL") {
                    return 'danger'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value == "OUTCALL") {
                    return "Gọi ra";
                } else if (value == "INCALL") {
                    return 'Gọi vào'
                } else if (value == "MISSCALL") {
                    return 'Gọi nhỡ'
                }
            }
        },
        chipColorStatus() {
            return value => {
                5
                if (value == 'MORE') {
                    return "success";
                } else if (value == 'MISSCALL') {
                    return 'warning'
                } else if (value == 'ANSWER') {
                    return 'success'
                } else if (value == 'BUSY') {
                    return 'danger'
                } else if (value == 'NOANSWER') {
                    return 'warning'
                } else if (value == 'CANCEL') {
                    return 'danger'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'warning'
                } else if (value == 'LOGOUT') {
                    return 'warning'
                } else if (value == 'INCALL') {
                    return 'warning'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'danger'
                }
            }
        },
        checkStatusStatus() {
            return value => {
                if (value == 'MORE') {
                    return "Nhiều trạng thái khác của cuộc gọi";
                } else if (value == 'MISSCALL') {
                    return 'Cuộc gọi nhỡ'
                } else if (value == 'ANSWER') {
                    return 'Nghe máy'
                } else if (value == 'BUSY') {
                    return 'Người nhận bận'
                } else if (value == 'NOANSWER') {
                    return 'Người nhận không trả lời'
                } else if (value == 'CANCEL') {
                    return 'Người gọi hủy cuộc gọi'
                } else if (value == 'SOMEONEANSWERED') {
                    return 'Đã có người khác nghe máy'
                } else if (value == 'LOGOUT') {
                    return 'Đang trong trạng thái Logout'
                } else if (value == 'INCALL') {
                    return 'Đang trong cuộc gọi khác'
                } else if (value == 'CONGESTION' || value == 'CHANUNAVAIL' || value == 'DONTCALL' || value == 'TORTURE' || value == 'INVALIDARGS' || value == 'ORMAL_CLEARING') {
                    return 'Lỗi cuộc gọi'
                }
            }
        },

        chipColorDisposition() {
            return value => {
                if (value == "BUSY") {
                    return "danger";
                } else if (value == "NOANSWER") {
                    return 'warning'
                } else if (value == "MISSCALL") {
                    return 'danger'
                } else if (value == "ANSWER") {
                    return 'success'
                } else if (value == "DONTCALL") {
                    return 'danger'
                } else if (value == "LOGOUT") {
                    return 'danger'
                }
            }
        },
        checkStatusDisposition() {
            return value => {
                if (value == "BUSY") {
                    return "Bận";
                } else if (value == "NOANSWER") {
                    return 'Không trả lời'
                } else if (value == "MISSCALL") {
                    return 'Gọi nhỡ'
                } else if (value == "ANSWER") {
                    return 'Nghe máy'
                } else if (value == "DONTCALL") {
                    return 'Từ chối'
                } else if (value == "LOGOUT") {
                    return 'Không hoạt động'
                }
            }
        },
    },

    created() {
        this.getDataEmployee();
        this.getAllCallHistory();
    },

    methods: {
        dateRangePicker: function () {
            this.startDate = new Date(this.startDate.setHours(0, 0, 0, 0));
            this.endDate = new Date(this.endDate.setHours(23, 59, 59, 999));
        },

        getAllCallHistory() {
            this.$vs.loading();
            this.callHistoryData = [];
            let body = {
                page: this.pageNumber,
                size: this.pageSize,
                phone: this.phoneNumber,
                employeeId: JSON.parse(this.selectedEmployeeValue),
                startDate: this.startDate,
                endDate: null,
                typeCall: this.selectedTypeCallValue,
                loyaltyCustomerName:this.loyaltyCustomerName
            }

            this.$crm.post('/ott/vbot/search-call-history', body).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.callHistoryData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.callerMem = el.caller && el.caller.length > 0 && el.caller[0].employee ? el.caller[0].employee.fullName : 'Không xác định';
                        el.callerMemPhone = el.caller && el.caller.length > 0 ? el.caller[0].phone : null;
                        el.calleeMem = (el.callee.length > 0 && el.callee[0].user) ? el.callee[0].user.fullName : 'Không xác định';
                        el.calleeMemPhone = el.callee.length > 0 ? el.callee[0].phone : null;
                        el.createdDate = moment(el.date_create).format('DD/MM/YYYY HH:mm');
                        el.createdDateCvt = moment(el.date_create).format('DD/MM/YYYY HH:mm:ss');
                        el.typeCall = el.type_call == 'OUTCALL' ? 'Cuộc gọi đi' : el.type_call == 'INCALL' ? 'Cuộc gọi đến' : el.type_call == 'MISSCALL' ? 'Cuộc gọi nhỡ' : null;
                        if (el.type_call == 'OUTCALL') {
                            el.employee = el.caller
                            el.customer = el.callee
                        } else {
                            el.employee = el.callee
                            el.customer = el.caller
                        }
                        return el;
                    });
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDataEmployee() {
            this.employeeOptions = [];
            let payload = {
                permissions: ['PRIVILEGE_VBOT_CUSTOMER_CALL']
            }
            this.$crm.post('/employee/get-employees-by-permissions', payload).then(res => {

                if (res.data && res.data.length > 0) {
                    this.employeeOptions = res.data.map(el => {
                        return {
                            value: el.id,
                            label: el.fullName
                        }
                    });
                    this.employeeOptions.unshift({
                        value: 'null',
                        label: 'Tất cả'
                    })
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllCallHistory();
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllCallHistory();
            }
        },

        filter() {
            if (this.startDate > this.endDate) {
                return this.$vs.notify({
                    text: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllCallHistory();
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        async rowClicked(params) {
            if (this.dataRecord) await this.deleteRecordFile();
            this.callHistoryDetails = params.data;
            this.rating = params.data.rating;
            if (this.rating) this.isRating = true;
            this.review = params.data.review;
            this.showCallHistoryDetails = true;
            console.log(this.callHistoryDetails)
        },

        async closeCallHistoryDetails() {
            if (this.dataRecord) await this.deleteRecordFile();
            this.showCallHistoryDetails = false;
            this.callHistoryDetails = null;
            this.rating = null;
            this.review = null;
            this.isRating = false;
        },

        async closeAudioRecord() {
            await this.deleteRecordFile();
            this.dataRecord = null;
            this.showAudioRecord = false;
        },

        startRecord(e) {
            let payload = {
                recordFileUrl: e
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/get-record-file', payload).then(res => {
                this.$vs.loading.close();
                if (res) {
                    this.dataRecord = authConfig.audioDomain + res.data;
                } else {
                    return this.$vs.notify({
                        text: 'Không tồn tại file ghi âm!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.showAudioRecord = true;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        saveReviewCall() {
            if (!this.rating) {
                return this.$vs.notify({
                    text: 'Vui lòng đánh giá chất lượng cuộc gọi!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let payload = {
                id: this.callHistoryDetails.id,
                rating: this.rating,
                review: this.review
            }
            this.$vs.loading();
            this.$crm.post('/ott/vbot/call-history-rating', payload).then(() => {
                this.$vs.notify({
                    text: 'Đánh giá cuộc gọi thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.closeCallHistoryDetails();
                this.getAllCallHistory();
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        deleteRecordFile() {
            return new Promise((resolve, reject) => {
                let payload = {
                    recordFileUrl: this.dataRecord,
                }

                this.$vs.loading();
                this.$crm.post('/ott/vbot/delete-record-file', payload).then(() => {
                    resolve();
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },

    async destroyed() {
        if (this.dataRecord) await this.deleteRecordFile();
    }
}
</script>

<style lang="scss">
#call_history {
    .ag-theme-material .ag-row {
        cursor: pointer;
    }
}
@media (min-width: 1200px) {
    [dir] .main-horizontal.navbar-sticky .router-content {
        margin-top: 4rem !important;
    }
}
#call_history {
    .vs-con-table {
        overflow-y: scroll;
        //height: 600px !important;

        .vs-table--content {
            overflow: visible !important;

            .vs-con-tbody {
                overflow: visible !important;
                width: 2500px !important;
                //overflow-x: scroll !important;
            }

            .vs-table--thead th {
                position: sticky;
                top: 0;
                background: #FFFFFF;
                z-index: 999;
            }

            tr:nth-child(even) {
                background-color: #f8f8f8;
            }
        }
    }

    .vs-table--thead tr th:last-child .vs-table-text {
        width: 100px;
    }

    .ag-grid-cell-chip-customer {
        &.vs-chip-primary {
            background: rgba(var(--vs-primary), .2);
            color: rgba(var(--vs-primary), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-success {
            background: rgba(var(--vs-success), .2);
            color: rgba(var(--vs-success), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-warning {
            background: rgba(var(--vs-warning), .2);
            color: rgba(var(--vs-warning), 1) !important;
            font-weight: 500;
        }

        &.vs-chip-danger {
            background: rgba(var(--vs-danger), .2);
            color: rgba(var(--vs-danger), 1) !important;
            font-weight: 500;
        }
    }
}

#popup-history-call {
    .vs-popup--header {
        display: none;
    }
}

#popup-history-call-record {
    .vs-popup--header {
        display: none;
    }
}

.nostar_desc {
    display: none !important;
}
</style>

<style>
.cell-class {
    display: flex;
    align-items: center;
}
</style>
